<template>
  <span>
    <span v-if="type === 'problemOccurs'">
      If the problem still occurs, please check your internet connection
      or contact us at
      <a href="mailto:hi@ahaslides.com">hi@ahaslides.com</a>
      for support.
    </span>
  </span>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: null,
    },
  },
}
</script>
